import { RefObject, useEffect, useRef, useState } from 'react';
import { userState } from '../../../atoms';
import { useRecoilValue } from 'recoil';
import { useSetAuth } from '../../../utils/useSetAuth';
import { useTranslation } from 'react-i18next';
import { todayYYYYMMDD } from '../../../utils/formatDate';
import useOnKeydownF9 from '../../../utils/useOnKeydownF9';
import { SearchOptions } from '../../../assets/styles/SearchOptions';
import styled from 'styled-components';
import RangePicker, { onChangeRangeInput } from '../../../components/RangePicker';
import dayjs from 'dayjs';
import ShortcutButton from '../../../components/button/ShortcutButton';
import { BtnBlue, BtnGhost, BtnGreen, BtnRed } from '../../../components/Button';
import SelectBox from '../../../components/SelectBox';
import useSetListCount from '../../../utils/useSetListCount';
import { FlutterFile, IComCdList } from 'customTypes';
import { LIST_COUNT, preJobTypeList } from '../../../_constants';
import { apiDelete, apiGet, apiPost } from '../../../services/_common';
import { logPost } from '../../../services/log';
import { setComCdListState } from '../../../utils/setComCdListState';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { isMobile } from '../../../utils/checkMobile';
import { InputTable } from '../../../assets/styles/InputTable';
import { useOutletContext } from 'react-router-dom';
import IssueGuide from '../../../components/IssueGuide';
import BackButton from '../../../components/BackButton';
import Input from '../../../components/Input';
import TextEditor from '../../../components/TextEditor';
import { applyBorderStyle } from '../../../utils/applyBorderStyle';
import { toast } from 'react-toastify';
import { readAndCompressImage } from 'browser-image-resizer';
import Portal from '../../../components/Portal';
import DashboardViewModalSlider from '../../../components/Modal/DashboardViewModalSlider';
import DeleteModal from '../../../components/Modal/DeleteModal';
import ClickableContainer from '../../s_cctv/S_cctv1/RealtimeCCTV/ClickableContainer';
import TableLamp from '../../../components/TableLamp';
import TextInfoBox from '../../../components/TextInfoBox';
import { v4 } from 'uuid';
import CustomCircleChkRenderer from '../../../components/CustomCircleChkRenderer';
import TuiGridWrapper from '../../../components/Table/TuiGridWrapper';
import TuiGrid from '../../../components/Table/TuiGrid';
import useTuiGridSize from '../../../hooks/useTuiGridSize';
import i18n from '../../../translation/i18n';
import { createRoot } from 'react-dom/client';
import { handleFlutterFilePicker } from '../../../hooks/crossPlatformHook/useFlutterFilePicker';
import SearchFilterModal from '../../../components/Modal/SearchFilterModal';
import { setupFlutterFileHandlers } from '../../../utils/flutterBridge';
import useBackHistory from '../../../hooks/useBackHistory';

const ButtonsWrapper = styled.div`
  border-top: 1px solid var(--outline);
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: flex-end;
  flex-wrap: wrap;
  button {
    height: 2.5rem;
    font-size: 0.875rem;
  }
  .inputNumber {
    display: flex;
    position: relative;
    width: 4.5rem;
    > span {
      user-select: none;
      position: absolute;
      right: 0;
      font-size: 0.875rem;
      top: 50%;
      margin-right: 0.5rem;
      color: rgba(0, 0, 0, 0.6);
      transform: translate(0, -50%);
    }
  }
  .description {
    /* height: 100%; */
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    font-size: 0.875rem;
    background-color: var(--tonal);
    color: var(--text-tertiary);
    line-height: 1;
    word-break: keep-all;
  }
  .addImgBtn {
    user-select: none;
    .material-symbols-rounded {
      font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
    }
    .fileButton {
      cursor: pointer;
      display: flex;
      align-items: center;
      /* padding: 0 1rem; */
      padding-right: 1rem;
      padding-left: 0.5rem;
      height: 2.5rem;
      border-radius: 0.25rem;
      font-size: 0.875rem;
      gap: 0.5rem;
      background-color: #007aff;
      color: white;

      &.disabled {
        color: #a2b0e0;
        background-color: var(--tonal-blue);
        cursor: not-allowed;
      }
    }
  }
`;

const Root = styled.div`
  &.hideRoot {
    visibility: hidden;
    position: absolute;
  }

  .inputFormsWrapper {
    display: flex;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid var(--outline);
    flex-grow: 0;
    flex-shrink: 0;
    gap: 0.5rem;
    color: #18181b;

    &.smallTab {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 0.5rem;
      font-weight: 500;
      overflow: hidden;
    }

    .tabMenuGroup {
      overflow: auto;
      width: 100%;

      .tabMenuGroupInner {
        display: flex;
        flex-wrap: nowrap;
        width: max-content;

        .tab {
          display: flex;
          align-items: center;
          width: max-content;
          padding: 0 0.5rem;
          height: 3.5rem;
          cursor: pointer;
          border-bottom: 2px solid transparent;
          color: var(--text-secondary);

          &.activeTab {
            font-weight: 700;
            border-bottom: 2px solid #3b82f6;
            color: #3b82f6;
          }
        }
      }
    }
  }

  .label {
    margin-left: 0.5rem;
    background-color: var(--filled-yellow);
    color: #fff;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
  }

  .tr-active {
    background-color: var(--tonal);
  }

  .custom-box {
    color: var(--text-primary);
  }
`;

const SubRoot = styled.div`
  width: calc(100% - 0.5rem) !important;
  height: fit-content;
  flex-grow: 1;
  margin-left: 0.5rem;
  overflow: auto;

  .tr-img-box {
    padding: 0.25rem !important;

    figure {
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 0.25rem;

      img {
        display: block;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }

  .inputForm {
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    gap: 0.5rem;
    overflow: auto;
    height: 100%;

    @media screen and (max-width: 1024px) {
      & {
        height: inherit;
      }
    }

    button {
      height: 2.5rem;
      font-size: 0.75rem;
      flex-shrink: 0;
      padding: 0 0.75rem;
      border-radius: 0.25rem;
    }
    button.gray {
      font-weight: 500;
      color: var(--zinc-200);
    }
    label {
      width: 6.5rem;
      font-weight: 500;
      flex-shrink: 0;
      font-size: 0.875rem;
    }
    .inputForm-group-1280 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1280px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1536px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536.withBtn {
      flex-direction: row;
      gap: 0.5rem;
      button {
        transition: none;
      }
      @media (min-width: 1536px) {
        gap: 2rem;
        button {
          margin-left: 0;
          width: fit-content;
        }
      }
    }
    .inputForm-group-1536.withBtn.inputColumnFour {
      input {
        padding: 0;
      }
    }
    .inputForm-row.labelInInput {
      display: flex;
      gap: 2rem;
      flex-grow: 1;
      @media screen and (max-width: 767px) {
        gap: 0.5rem;
      }
      > div {
        flex-grow: 1;
      }
    }
    .inputForm-row.labelInInput.noGrow {
      flex-grow: 0;
    }
    .inputForm-row.labelInInput.noGrow.title > div > div {
      flex-direction: column;
      align-items: flex-start;
    }
    .inputForm-row.labelOutInput,
    .inputForm-row.labelInInput > div > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      flex-grow: 1;
      input {
        flex-shrink: 1;
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 0.5rem;
        &:disabled {
          background-color: var(--tonal);
          color: var(--text-disabled);
        }
      }
      > div.viewOnly {
        height: 2.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-disabled);
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        display: flex;
        align-items: center;
      }
      > div {
        flex-grow: 1;
        > ul {
          height: 2.5rem;
          li {
            display: flex;
            width: 100%;
            max-width: 100%;
            span {
              flex-grow: 1;
              width: 4rem;
            }
          }
        }
      }
    }
    .detailInfo-group {
      margin: 1rem 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      @media (min-width: 1536px) {
        grid-template-columns: repeat(3, 1fr);
      }
      .flex-col.detailInfo {
        flex-grow: 1;
        width: 100%;
        div {
          height: 2.5rem;
          color: var(--text-tertiary);
          background-color: var(--tonal);
          border-radius: 0.25rem;
          display: flex;
          align-items: center;
          padding: 0 0.5rem;
          font-size: 0.875rem;
        }
      }
    }
  }

  .editorWrapper .ck-content {
    min-height: 10rem;
    max-height: 12rem;
  }

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

class CustomHTMLRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const root = createRoot(this.element);
    const { val1, val2 } = props.columnInfo.renderer.options.data[props.rowKey];
    const { labelName } = props.columnInfo.renderer.options;

    root.render(
      <div className='custom-box'>
        {val1}
        {val2 !== '' && <span className='label'>{labelName}</span>}
      </div>
    );
  }

  getElement() {
    return this.element;
  }
}

// Compression configuration
const config = {
  quality: 0.7,
  maxWidth: 800,
  maxHeight: 600,
  autoRotate: true,
  debug: true,
};

const DRAGGABLE_ITEM_TYPE = 'ROW';

const DraggableRow = ({ el, index, moveRow, boardState, setBoardState, onClickDeleteBoardD, userInfo, auth, isEnable }: any) => {
  const { t } = useTranslation();
  const trRef = useRef(null);
  const newCdArray = boardState.map((elParam: any) => elParam.cdSort);
  const cdSortArray = newCdArray.sort((a: number, b: number) => a - b);

  const [, drop] = useDrop({
    accept: DRAGGABLE_ITEM_TYPE,
    hover(item: any, monitor) {
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: (item, monitor) => {
      const copyArray = [...boardState];
      const newArray = copyArray.map((cpItem, cpIndex) => {
        return {
          ...cpItem,
          cdSort: cdSortArray[cpIndex],
        };
      });

      setBoardState(newArray);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: DRAGGABLE_ITEM_TYPE,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(trRef));

  return (
    <div ref={trRef} style={{ opacity: isDragging ? 0 : 1 }} key={el.idx}>
      <div className='tr' role='button' tabIndex={0}>
        <div className='trCol2p5 tableStickyNo flex-center'>{index + 1}</div>
        <div className='trCol6 flex-basic tr-img-box'>
          <figure>
            <img height={60} src={el.imgPath} alt={el.imgName} />
          </figure>
        </div>
        <div className='trCol20 flex-basic content-overflow'>{el.imgName}</div>
        {auth.deleteAuth && isEnable && (
          <div className='trCol4 flex-center'>
            <BtnRed onClick={() => onClickDeleteBoardD(el, index)}>{el.index === undefined ? t('삭제') : t('제거')}</BtnRed>
          </div>
        )}
      </div>
    </div>
  );
};

const CBT_DEFAULTS = [
  { type: 'cbtYn', cbtYn: 'A', cdName: '전체' },
  { type: 'cbtYn', cbtYn: 'Y', cdName: '적용' },
  { type: 'cbtYn', cbtYn: 'N', cdName: '미적용' },
];

interface FlutterFileData {
  name: string;
  path: string;
  size: number;
  extension: string;
  base64?: string;
}

const Correct = () => {
  const userInfo = useRecoilValue(userState);
  const { auth } = useSetAuth();
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const toDay = todayYYYYMMDD();
  const { isF9Pressed, setIsF9Pressed } = useOnKeydownF9(); // f9키 프레스 훅
  const mobile = isMobile();
  const [CORRECT_TAB, ACTION_TAB] = [0, 1]; // 시정사항, 조치내용

  const INIT_ROW_STATE = {
    cCd: userInfo.hCd,
    cbtCd: '',
    cbtTitle: '',
    cbtContents: '',
    cbtRcontents: '',
    cbtDefault: 'Y',
    writer: '',
    wDate: '',
    editor: '',
    eDate: '',
    rwriter: '',
    rwDate: '',
    reditor: '',
    reDate: '',
  };

  const [loading, setLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(CORRECT_TAB); // 하위메뉴의 내부탭 액티브상태값
  const [isNewAdd, setIsNewAdd] = useState<boolean>(true); // 신규추가 여부
  const [listCountComCdList, setListCountComCdList] = useState<IComCdList[]>([]); // 검색줄수 공통코드
  const { listCount, setListCount, patchUserMenuAPI } = useSetListCount(); // 검색줄수설정 훅
  const [searchOption, setSearchOption] = useState({ cbtTitle: '', contents: '', start: toDay, end: toDay });
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [rangeState, setRangeState] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
  const [visibleRangePicker, setVisibleRangePicker] = useState<boolean>(false);
  const [selectedRowKey, setSelectedRowKey] = useState('');
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [newFileCount, setNewFileCount] = useState(0); // 신규 추가하는 파일 개수

  const [cbtYn, setCbtYn] = useState({ type: 'cbtYn', cbtYn: 'A', cdName: t('전체') });
  const [openModal, setOpenModal] = useState<any>({ status: false, type: '', title: '' });
  const [showSubTable, setShowSubTable] = useState({ status: true, ibtCd: '', ibtName: '' });
  const [tableState, setTableState] = useState<any[]>([]);
  const [rowState, setRowState] = useState<any>(INIT_ROW_STATE);
  const [editorData, setEditorData] = useState<string>('');
  const [openSubPage, setOpenSubPage] = useState(false);

  const [columns, setColumns] = useState<any[]>([]);
  const [boardDtableState, setBoardDtableState] = useState<any>([]); // 시정사항 이미지 리스트
  const [boardRDtableState, setBoardRDtableState] = useState<any>([]); // 조치내용 이미지 리스트

  const cbtTitleRef = useRef<HTMLInputElement>(null);
  const contentRef = useRef<HTMLInputElement>(null);
  const inputFileRef = useRef<HTMLInputElement | null>(null);
  const scrollContainerRef = useRef<HTMLInputElement>(null);
  const componentRef = useRef<HTMLDivElement>(null);
  const { tuiHeight } = useTuiGridSize(componentRef);
  const [isThrottle, setIsThrottle] = useState<boolean>(false); // 쓰로틀링 플래그 설정

  const Backend = mobile ? TouchBackend : HTML5Backend;

  // 신규추가시 스크롤 마지막으로 이동
  /*
    useEffect(() => {
      if (addRowStatus) {
        if (scrollContainerRef.current) scrollContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setAddRowStatus(false);
      }
    }, [addRowStatus]);
    */

  useEffect(() => {
    getCorrectBoardAPI();
    setComCdListState(LIST_COUNT, setListCountComCdList, false);
    logPost({
      hCd: userInfo.hCd,
      sCd: userInfo.sCd,
      userId: userInfo.userId,
      menu: '안전관리/게시판 > 시정 사항',
      action: '조회',
      etc: ``,
    });
  }, []);

  const getCorrectBoardAPI = async (isSearch?: boolean) => {
    const req = { cCd: userInfo.hCd };
    const res = await apiGet({ path: '/safe/correctboard', req });
    const { statusCode, data } = res.data;
    if (statusCode === 200) {
      const searchFilter = {
        cbtDefault: cbtYn.cbtYn || 'Y',
        cbtTitle: searchOption.cbtTitle,
      };
      const startDate = searchOption.start ? dayjs(searchOption.start).format('YYYYMMDD') : '';
      const endDate = searchOption.end ? dayjs(searchOption.end).format('YYYYMMDD') : '';
      // 날짜 필터링
      const filterDate = data.filter((el: any) => {
        const wDate = dayjs(el.wDate).format('YYYYMMDD');
        return (startDate ? wDate >= startDate : true) && (endDate ? wDate <= endDate : true);
      });

      const filteredData = filterDate.filter((item: any) => {
        return Object.entries(searchFilter).every(([key, filterValue]) => {
          if (filterValue === 'A' || filterValue === '') return true; // 필터 값이 'A'이면 기준 무시 (return true)
          if (key === 'cbtTitle') return item[key]?.toLowerCase()?.includes(filterValue?.toLowerCase());

          return item[key] === filterValue; // 그렇지 않으면 항목의 속성이 필터의 속성과 일치하는지 확인
        });
      });

      // 시정사항 내용 필터링
      const content1 = filteredData.filter((item: any) => {
        return item?.cbtContents
          ?.replace(/(<[^>]+>)/gi, '')
          .toLowerCase()
          ?.includes(searchOption.contents?.toLowerCase());
      });

      // 조치내용 필터링
      const content2 = filteredData.filter((item: any) => {
        if (item?.cbtRcontents !== '')
          return item?.cbtRcontents
            ?.replace(/(<[^>]+>)/gi, '')
            .toLowerCase()
            ?.includes(searchOption.contents?.toLowerCase());
        return false;
      });

      const setFilter = new Set([...content1, ...content2]); // 합친 이후 중복 제거
      const newArr = [...setFilter];
      setTableState(newArr);

      // 저장시 조회한 데이터에서 저장한 고유값을 꺼내와서 row에 담기 | 검색일때는 row값 초기화
      if (!isSearch && selectedRowIndex) {
        const findRow = newArr.find((el: any) => el.cbtCd === selectedRowIndex) || INIT_ROW_STATE;
        setRowState(findRow);
      }
    }
    return res;
  };

  useEffect(() => {
    setColumns([
      {
        header: t('시정사항 제목'),
        name: 'cbtTitle',
        align: 'left',
        sortable: true,
        minWidth: 400,
        renderer: {
          type: CustomHTMLRenderer,
          options: {
            data: tableState.map((el: any) => ({ val1: el.cbtTitle, val2: el.cbtRcontents })),
            labelName: t('조치'),
          },
        },
      },
      {
        header: t('작성일자'),
        name: 'wDate',
        align: 'center',
        sortable: true,
        minWidth: 120,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('상황판'),
        name: 'cbtDefault',
        align: 'center',
        sortable: true,
        width: 80,
        renderer: {
          type: CustomCircleChkRenderer,
        },
      },
    ]);
  }, [i18n.language, tableState]);

  // 날짜 포멧 적용
  useEffect(() => {
    if (rangeState[0].startDate) {
      setSearchOption((prev: any) => ({ ...prev, start: dayjs(rangeState[0].startDate).format('YYYY-MM-DD') }));
    }
    if (rangeState[0].endDate) {
      setSearchOption((prev: any) => ({ ...prev, end: dayjs(rangeState[0].endDate).format('YYYY-MM-DD') }));
    }
  }, [rangeState[0].startDate, rangeState[0].endDate]);

  // f9 search
  useEffect(() => {
    if (isF9Pressed) {
      onClickSearch();
      setIsF9Pressed(false);
    }
  }, [isF9Pressed]);

  // 탭 변경시
  useEffect(() => {
    if (activeTab === CORRECT_TAB) {
      setEditorData(rowState.cbtContents);
    } else {
      setEditorData(rowState.cbtRcontents);
    }
  }, [activeTab]);

  // 검색 버튼 클릭
  const onClickSearch = (filterRef?: RefObject<HTMLDivElement>) => {
    setLoading(true);
    if (filterRef) {
      // 모바일일 경우 검색 필터 모달 창 닫기
      filterRef.current?.classList.remove('active');
      setOpenModal({ status: false, type: 'filter' });
    }
    initialState();
    getCorrectBoardAPI(true).then((res: any) => {
      if (res.status === 200) {
        setComCdListState(LIST_COUNT, setListCountComCdList, false);
        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '안전관리/게시판 > 시정 사항',
          action: '조회',
          etc: ``,
        });
        setLoading(false);
      }
    });
  };

  const onEnterKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onClickSearch();
    }
  };

  // 초기화 버튼 클릭
  const onClickInitiateSearchOption = () => {
    setIsNewAdd(true);
    initialState();
    setCbtYn({ type: 'cbtYn', cbtYn: 'A', cdName: t('전체') });
    Object.keys(searchOption).map((el: any) => {
      return setSearchOption((prev) => ({ ...prev, [el]: '', start: '', end: '' }));
    });
    setRangeState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
  };

  const onClickRangeInput = () => {
    if (!visibleRangePicker) setVisibleRangePicker(true);
  };

  const initialState = () => {
    setIsNewAdd(true);
    setIsSaveClicked(false);
    setRowState(INIT_ROW_STATE);
    setActiveTab(CORRECT_TAB);
    setBoardDtableState([]);
    setBoardRDtableState([]);
    setSelectedRowIndex(null);
    setSelectedRowKey('');
    setEditorData('');
  };

  const onClickNewAdd = () => {
    initialState();
    setOpenSubPage(true);
  };

  const onClickRow = (el: any) => {
    setIsNewAdd(false);
    setSelectedRowIndex(el.cbtCd);
    setSelectedRowKey(el.rowKey);
    setBoardDtableState(el.boardD.map((img: any) => ({ ...img, idx: img.cbdCd, imgBase64: '', imgPath: img.cFilename, imgName: img.cFilename.slice(img.cFilename.lastIndexOf('/') + 1) })));
    setBoardRDtableState(el.rBoardD.map((img: any) => ({ ...img, idx: img.cbdCd, imgBase64: '', imgPath: img.cFilename, imgName: img.cFilename.slice(img.cFilename.lastIndexOf('/') + 1) })));

    if (activeTab === CORRECT_TAB) {
      setRowState(el);
      setEditorData(el.cbtContents);
    } else {
      setRowState(el);
      setEditorData(el.cbtRcontents);

      if (el.cbtRcontents === '') {
        setActiveTab(CORRECT_TAB);
      }
    }

    if (size.innerSize.W <= 1024) {
      setOpenSubPage(true);
    }
  };

  const moveRow = (fromIndex: number, toIndex: number) => {
    if (activeTab === CORRECT_TAB) {
      const updatedData = [...boardDtableState];
      const [movedItem] = updatedData.splice(fromIndex, 1);
      updatedData.splice(toIndex, 0, movedItem);
      setBoardDtableState(updatedData);
    } else {
      const updatedData = [...boardRDtableState];
      const [movedItem] = updatedData.splice(fromIndex, 1);
      updatedData.splice(toIndex, 0, movedItem);
      setBoardRDtableState(updatedData);
    }
  };

  const onClickDeleteImg = (el: any, i: number) => {
    if (el.cFilename === undefined) {
      // 새로 추가한 로우 제거 클릭 시
      const updatedArray = activeTab === CORRECT_TAB ? [...boardDtableState] : [...boardRDtableState];
      updatedArray.splice(i, 1);
      activeTab === CORRECT_TAB ? setBoardDtableState(updatedArray) : setBoardRDtableState(updatedArray);
    } else {
      // 삭제 시 에디터아이디 추가
      const data = el;
      setOpenModal((prev: any) => ({
        ...prev,
        status: true,
        type: 'array',
        title: 'imgDelete',
        state: activeTab === CORRECT_TAB ? boardDtableState : boardRDtableState,
        setState: activeTab === CORRECT_TAB ? setBoardDtableState : setBoardRDtableState,
        api: () => deleteImageAPI(el),
        el: data,
        index: i,
      }));
    }
  };

  const deleteImageAPI = async (el: any) => {
    const req = { cCd: userInfo.hCd, cbtCd: rowState.cbtCd, cbdCd: el.cbdCd };
    const res = await apiDelete({ path: '/safe/correctboardd', req });
    const { statusCode, data } = res.data;
    if (statusCode === 200) {
      setOpenModal((prev: any) => ({ ...prev, status: false }));

      const newMap = data.map((imgData: any) => ({
        imgBase64: '',
        imgPath: imgData.cFilename,
        imgName: imgData.cFilename.slice(imgData.cFilename.lastIndexOf('/') + 1),
      }));
      activeTab === CORRECT_TAB ? setBoardDtableState(newMap) : setBoardRDtableState(newMap);
      getCorrectBoardAPI();

      toast.success(t('삭제되었습니다'));
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '안전 관리/게시판 관리 > 시정 사항',
        action: `이미지 삭제`,
        etc: `API : /safe/correctboardd`,
      });
    } else {
      // toast.error(t(ERROR));
    }
  };

  /* 엔터키 검색 기능 ( 활성화시 F9키 처럼 횟수 제한 필요 )
  const loginOnEnterKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (cbtTitleRef.current) onClickSearch();
    }
  };
  */

  // 상황판 적용 유무
  const onClickCbtYn = (val: 'Y' | 'N') => {
    const newUseYn = val === 'Y' ? 'N' : 'Y';
    setRowState((prev: any) => ({ ...prev, cbtDefault: newUseYn }));
  };

  // 뒤로가기 버튼 클릭
  const backToMain = () => {
    initialState();
    setSelectedRowKey('');
    setSelectedRowIndex(null);
    setOpenSubPage(false);
  };

  const { onBackPrev } = useBackHistory({ isOpen: openSubPage, onPrev: backToMain, pageName: 'correctPage' });

  const createImageData = (flutterFile: FlutterFile, file: FlutterFileData, prevLength: number) => ({
    idx: v4(),
    cbdCd: '',
    cdSort: prevLength + 1,
    imgBase64: flutterFile?.base64?.split(',')[1] ?? '',
    imgName: file.name,
    imgPath: flutterFile?.base64 ?? '',
  });

  useEffect(() => {
    const cleanup = setupFlutterFileHandlers(
      (fileData) => {
        if (activeTab === CORRECT_TAB) {
          setBoardDtableState((prev: any) => [...prev, createImageData({ ...fileData, base64: fileData.base64 }, fileData, prev.length)]);
        } else {
          setBoardRDtableState((prev: any) => [...prev, createImageData({ ...fileData, base64: fileData.base64 }, fileData, prev.length)]);
        }
      },
      (error) => {
        console.error('파일 선택 오류:', error);
      }
    );

    return cleanup;
  }, [activeTab]);

  // 파일 업로드
  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>, currentTab: number) => {
    // 한번에 최대 10개의 파일까지만 첨부할수 있도록 제한
    if (newFileCount < 10) {
      const fileList = event.target.files;

      // 웹에서만 파일 처리
      if (!window.FilePicker && fileList && fileList.length > 0) {
        if (fileList) {
          const MAX_FILE_SIZE_MB = 5;
          const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // convert to bytes

          const fileListArray = Array.from(Object.values(fileList));
          const smallFiles = fileListArray.filter((file) => file.size <= MAX_FILE_SIZE_BYTES);

          if (fileListArray.length !== smallFiles.length) {
            toast.warning(t(`파일크기는 5MB를 초과할 수 없습니다`));
          }
          const combinedArray = [...smallFiles];
          compressAndUploadImages(combinedArray, currentTab);
          setNewFileCount((prev) => prev + 1);
        }
      }
    } else {
      toast.warning(t('최대 10개 이미지까지 첨부 가능합니다'));
    }
    // 입력 필드 초기화는 파일 처리 후에 수행
    if (event.target) {
      event.target.value = '';
    }
  };

  // 이미지 압축
  const compressAndUploadImages = async (selectedFilesParam: File[], currentTab: number) => {
    try {
      const compressedImages = await Promise.all(selectedFilesParam.map((file) => readAndCompressImage(file, config)));
      // 압축한 파일을 base64로 변환
      const promises = compressedImages.map((file, i) => {
        return new Promise((resolve) => {
          const fileReader = new FileReader();

          fileReader.onload = (e) => {
            const base64String = e.target!.result as string;
            resolve({
              idx: v4(),
              cbdCd: '',
              cdSort: currentTab === CORRECT_TAB ? boardDtableState.length + i + 1 : boardRDtableState.length + i + 1,
              imgBase64: base64String.split(',')[1],
              imgName: selectedFilesParam[i].name,
              imgPath: base64String,
            });
          };
          fileReader.readAsDataURL(file);
        });
      });

      const resultArray: any = await Promise.all(promises);
      currentTab === CORRECT_TAB ? setBoardDtableState((prev: any[]) => [...prev, ...resultArray]) : setBoardRDtableState((prev: any[]) => [...prev, ...resultArray]);
    } catch (error) {
      toast.error(t('이미지 압축 중 에러 발생 다시 시도하세요'));
      console.error(error);
    }
  };

  const onClickPreview = (imgList: any) => {
    if (showSubTable.status) {
      if (imgList && imgList.length === 0) toast.warning(t('게시판 이미지가 없습니다'));
      else {
        setOpenModal((prev: any) => ({ ...prev, status: true, type: 'dashboardView', data: imgList }));
      }
    } else toast.warning(t('게시판 항목을 선택하세요'));
  };

  // 시정 & 조치 삭제
  const onClickDelete = async (currentTab: number) => {
    setOpenModal((prev: any) => ({ ...prev, status: true, type: 'delete', title: 'delete', api: () => deleteAPI(currentTab), withoutRowDelete: true }));
  };

  const deleteAPI = async (currentTab: number) => {
    const path = currentTab === CORRECT_TAB ? '/safe/correctboard' : '/safe/correctboard/r';
    const req = { cCd: userInfo.hCd, cbtCd: rowState.cbtCd };
    const res = await apiDelete({ path, req });
    const { statusCode } = res.data;

    if (statusCode === 200) {
      getCorrectBoardAPI();
      initialState();

      toast.success(t('삭제되었습니다'));
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '안전 관리/게시판 관리 > 시정 사항',
        action: `조치내용 삭제`,
        etc: `시정사항 제목 : ${rowState.cbtTitle}`,
      });
    }
  };

  // 시정 & 조치 저장
  const onClickSave = async (currentTab: number) => {
    setIsSaveClicked(true);

    if (rowState.cbtTitle === '') {
      if (!isThrottle) {
        toast.warning(t('제목을 입력하세요'));
        setIsThrottle(true);
        setTimeout(() => setIsThrottle(false), 2000); // alert은 2초에 1번만 실행되게 설정
      }
      return;
    }

    if (
      editorData
        .replace(/(<[^>]+>)/gi, '')
        .replaceAll('&nbsp;', '')
        .trim() === ''
    ) {
      if (!isThrottle) {
        toast.warning(t('내용을 입력하세요'));
        setIsThrottle(true);
        setTimeout(() => setIsThrottle(false), 2000); // alert은 2초에 1번만 실행되게 설정
      }
      return;
    }

    const path = currentTab === CORRECT_TAB ? '/safe/correctboard' : '/safe/correctboard/r';
    const ccorrectBoardDReqDto =
      currentTab === CORRECT_TAB
        ? boardDtableState.map((el: any) => ({ cbdCd: el.cbdCd, cdSort: el.cdSort, imgBase64: el.imgBase64 }))
        : boardRDtableState.map((el: any) => ({ cbdCd: el.cbdCd, cdSort: el.cdSort, imgBase64: el.imgBase64 }));

    const correctReq = {
      cbtTitle: rowState.cbtTitle,
      cbtDefault: rowState.cbtDefault,
      cbtContents: editorData,
    };

    const req = {
      cCd: userInfo.hCd,
      cbtCd: rowState.cbtCd !== '' ? rowState.cbtCd : '',
      ccorrectBoardDReqDto,
      ...(currentTab === CORRECT_TAB && correctReq),
      ...(currentTab === ACTION_TAB && { cbtRcontents: editorData }),
    };

    if (!isThrottle) {
      setIsThrottle(true);
      const res = await apiPost({ path, contentType: 'application/json', req });
      const { statusCode, data } = res.data;

      if (statusCode === 200) {
        setTimeout(() => setIsThrottle(false), 2000);
        getCorrectBoardAPI();

        // 최초 등록 시
        if (isNewAdd) {
          const newRowFind = tableState.find((el: any) => el.cbtTitle === rowState.cbtTitle); // 새로 생성한 글이 검색조건에 의해서 보여지지 않을 시 셀렉트 제거
          setSelectedRowKey(newRowFind && newRowFind !== undefined ? '0' : ''); // 새로 생성한 글이 검색조건에 포함 시 최상단 셀렉트
          setRowState(data[0]);
          setIsNewAdd(false); // 수정 모드 전환
        }
        if (isNewAdd) {
          toast.success(t('등록되었습니다'));
          await logPost({
            hCd: userInfo.hCd,
            sCd: userInfo.sCd,
            userId: userInfo.userId,
            menu: '시정 사항',
            action: '시정 사항 등록',
            etc: `제목 : ${rowState.cbtTitle}`,
          });
        } else {
          toast.success(t('수정되었습니다'));
          await logPost({
            hCd: userInfo.hCd,
            sCd: userInfo.sCd,
            userId: userInfo.userId,
            menu: '시정 사항',
            action: '시정 사항 수정',
            etc: `제목 : ${rowState.cbtTitle}`,
          });
        }
      }
    }
  };

  // 필터 버튼 클릭
  const onClickFilter = () => {
    setOpenModal({ status: true, type: 'filter' });
  };

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <Root className={size.innerSize.W > 1024 || (size.innerSize.W <= 1024 && !openSubPage) ? 'showRoot' : 'hideRoot'}>
        <SearchOptions align='left'>
          {size.innerSize.W > 1024 ? (
            <>
              <div className='inputsWrapper'>
                <div className='inputForm-row withLabel'>
                  <label htmlFor='cbtYn'>{t('상황판 적용유무')}</label>
                  <div className='inputForm-col'>
                    <SelectBox
                      options={CBT_DEFAULTS}
                      defaultOption={t('전체')}
                      state={cbtYn}
                      setState={setCbtYn}
                      stateKey='cbtYn'
                      initiateKey={cbtYn.cbtYn}
                      filterbar='filter-1-left'
                      optionHeight='height-md'
                    />
                  </div>
                </div>
                <div className='inputForm-row-fit'>
                  <span className='calendarLabel'>{t('작성일자')}</span>
                  <div className='inputForm-col'>
                    <div className='flex-basic'>
                      <input id='startInput' type='text' value={searchOption.start} onChange={(e) => onChangeRangeInput(e, 'start', setRangeState, setSearchOption)} />
                      <span className='inputDash'> ~ </span>
                      <input id='endInput' type='text' value={searchOption.end} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setSearchOption)} />
                    </div>
                    {visibleRangePicker && (
                      <div className='rangePickerWrapper'>
                        <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} style={{ left: '70%' }} />
                      </div>
                    )}
                  </div>
                  <button type='button' className='date-picker-btn' onClick={onClickRangeInput}>
                    <span className='material-symbols-rounded'>calendar_month</span>
                  </button>
                </div>

                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    <Input
                      placeholder={t('제목')}
                      label=''
                      type='text'
                      id='cbtTitle'
                      name='cbtTitle'
                      state={searchOption}
                      setState={setSearchOption}
                      inputRef={cbtTitleRef}
                      // onKeyDown={loginOnEnterKeyDown}
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    <Input
                      placeholder={t('내용')}
                      label=''
                      type='text'
                      id='contents'
                      name='contents'
                      state={searchOption}
                      setState={setSearchOption}
                      inputRef={contentRef}
                      // onKeyDown={loginOnEnterKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='secondSearchOption'>
                  <div className='flex-basic textBtnGroup'>
                    <ShortcutButton icon='search' buttonText='검색' shortcut='F9' onClick={onClickSearch} />
                    <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                    <div className='searchResult'>
                      {t('총')}
                      <span>{tableState.length}</span>
                      {t('개')}
                    </div>
                    <div className='inputForm-row'>
                      <div className='inputForm-col withLabelComCf'>
                        <label htmlFor='useYn'>{t('보기 설정')}</label>
                        <SelectBox
                          options={listCountComCdList}
                          defaultOption={listCount.cdName}
                          state={listCount}
                          setState={setListCount}
                          stateKey={LIST_COUNT}
                          initiateKey={listCount[LIST_COUNT]}
                          setTableLinesAPI={patchUserMenuAPI}
                          optionHeight='height-sm'
                          rsearch
                        />
                      </div>
                    </div>
                  </div>
                  {auth.createAuth && (
                    <div className='flex-basic iconBtnGroup'>
                      <BtnGhost onClick={onClickNewAdd}>
                        <span className='material-symbols-rounded'>add</span>
                        {t('등록')}
                      </BtnGhost>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className='filter-wrapper'>
              <div className='inputsWrapper'>
                <div className='inputForm-row' style={{ width: 'calc(100% - 3.5rem)' }}>
                  <div className='inputForm-col'>
                    <Input
                      placeholder={t('제목')}
                      label=''
                      type='search'
                      id='cbtTitle'
                      name='cbtTitle'
                      state={searchOption}
                      setState={setSearchOption}
                      inputRef={cbtTitleRef}
                      onKeyDown={onEnterKeyDown}
                      ico='search'
                    />
                  </div>
                </div>
                <BtnGhost onClick={onClickFilter} className='filter-btn'>
                  <span className='material-symbols-rounded'>filter_alt</span>
                </BtnGhost>
              </div>
              {auth.createAuth && (
                <div className='inputsWrapper'>
                  <div className='flex-basic iconBtnGroup'>
                    <BtnGhost onClick={onClickNewAdd}>
                      <span className='material-symbols-rounded'>add</span>
                      {t('등록')}
                    </BtnGhost>
                  </div>
                </div>
              )}
            </div>
          )}
        </SearchOptions>

        <TuiGridWrapper componentRef={componentRef}>
          <TuiGrid
            data={tableState}
            columns={columns}
            onClickRow={onClickRow}
            perPage={Number(listCount[LIST_COUNT])}
            rowKey={selectedRowKey}
            scrollX
            height={tuiHeight}
            frozenCount={0}
            usePagenation
            idxKey='cbtCd'
          />
        </TuiGridWrapper>
      </Root>

      {(size.innerSize.W > 1024 || (size.innerSize.W <= 1024 && openSubPage)) && (
        <Root>
          <div className='inputFormsWrapper smallTab'>
            {size.innerSize.W <= 1024 && <BackButton func={onBackPrev} />}
            <div className='tabMenuGroup'>
              <div className='tabMenuGroupInner'>
                <div className={`tab ${activeTab === CORRECT_TAB ? 'activeTab' : undefined}`} role='button' tabIndex={0} onClick={() => setActiveTab(CORRECT_TAB)}>
                  {t('시정 사항')}
                </div>

                <div className={`tab ${activeTab === ACTION_TAB ? 'activeTab' : undefined}`} role='button' tabIndex={0} onClick={() => setActiveTab(ACTION_TAB)}>
                  {t('조치 내용')}
                </div>
              </div>
            </div>
          </div>

          <SubRoot>
            <div className='inputForm'>
              {activeTab === CORRECT_TAB && (
                <div className='inputForm-group-row'>
                  <div className='inputForm-row labelInInput' style={{ flexWrap: 'wrap' }}>
                    <Input
                      className='cbtTitle required'
                      label={t('제목')}
                      type='text'
                      id='cbtTitle'
                      name='cbtTitle'
                      state={rowState}
                      setState={setRowState}
                      disabled={isNewAdd ? !auth.updateAuth : !(auth.updateAuth && (userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer))}
                      getBorderStyle={isSaveClicked ? applyBorderStyle(rowState.cbtTitle, 'red', 'cbtTitle') : undefined}
                    />
                    <div className='flex-basic noGrow' style={{ gap: '0.25rem' }}>
                      <label htmlFor='cbtDefault'>{t('상황판 적용 유무')}</label>
                      <ClickableContainer button={<TableLamp use={rowState.cbtDefault === 'Y'} />} onClick={() => onClickCbtYn(rowState.cbtDefault)} />
                    </div>
                  </div>
                </div>
              )}

              <div className='editorWrapper'>
                <TextEditor
                  content={editorData}
                  setContent={setEditorData}
                  readOnly={false}
                  disabled={isNewAdd ? !auth.updateAuth : !(auth.updateAuth && (userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer))}
                />
              </div>

              <DndProvider backend={Backend}>
                <InputTable style={{ height: '100%', overflow: 'hidden' }}>
                  <TextInfoBox ico='lightbulb' description={t('드래그 앤 드롭을 지원합니다. 행 순서를 위,아래로 변경하세요')} color='orange' />
                  <div className='thead'>
                    <div className='tr'>
                      <div className='trCol2p5 flex-center tableStickyNo'>No</div>
                      <div className='trCol6 flex-center'>{t('썸네일')}</div>
                      <div className='trCol20 flex-center content-overflow'>{t('파일')}</div>
                      {auth.deleteAuth && <div className='trCol4 flex-center'> </div>}
                    </div>
                  </div>

                  <div className='table img' style={{ overflowY: 'auto' }}>
                    <div className='tbody'>
                      {activeTab === CORRECT_TAB && showSubTable.status && boardDtableState?.length > 0 ? (
                        boardDtableState.map((el: any, index: number) => (
                          <DraggableRow
                            key={el.idx}
                            index={index}
                            el={el}
                            moveRow={moveRow}
                            boardState={boardDtableState}
                            setBoardState={setBoardDtableState}
                            onClickDeleteBoardD={onClickDeleteImg}
                            userInfo={userInfo}
                            auth={auth}
                            isEnable={isNewAdd || userInfo.gCd === 'MM' || userInfo.userName === rowState.writer}
                          />
                        ))
                      ) : activeTab === ACTION_TAB && showSubTable.status && boardRDtableState?.length > 0 ? (
                        boardRDtableState.map((el: any, index: number) => (
                          <DraggableRow
                            key={el.idx}
                            index={index}
                            el={el}
                            moveRow={moveRow}
                            boardState={boardRDtableState}
                            setBoardState={setBoardRDtableState}
                            onClickDeleteBoardD={onClickDeleteImg}
                            userInfo={userInfo}
                            auth={auth}
                            isEnable={isNewAdd || userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer}
                          />
                        ))
                      ) : (
                        <div className='no-data'>
                          <IssueGuide />
                        </div>
                      )}
                    </div>
                  </div>
                </InputTable>
              </DndProvider>

              {activeTab === CORRECT_TAB && !isNewAdd && (userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer) && (
                <div className='detailInfo-group'>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='createDate'>{t('등록일자')}</label>
                    <div>{rowState?.wDate}</div>
                  </div>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='createUser'>{t('등록자')}</label>
                    <div>{rowState.writer}</div>
                  </div>

                  <div className='flex-col detailInfo'>
                    <label htmlFor='updateDate'>{t('수정일자')}</label>
                    <div>{rowState.eDate}</div>
                  </div>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='updateUser'>{t('수정자')}</label>
                    <div>{rowState.editor}</div>
                  </div>
                </div>
              )}

              {activeTab === ACTION_TAB && !isNewAdd && rowState?.rwDate && (userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer) && (
                <div className='detailInfo-group'>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='createDate'>{t('등록일자')}</label>
                    <div>{rowState?.rwDate}</div>
                  </div>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='createUser'>{t('등록자')}</label>
                    <div>{rowState?.rwriter}</div>
                  </div>

                  <div className='flex-col detailInfo'>
                    <label htmlFor='updateDate'>{t('수정일자')}</label>
                    <div>{rowState?.reDate}</div>
                  </div>
                  <div className='flex-col detailInfo'>
                    <label htmlFor='updateUser'>{t('수정자')}</label>
                    <div>{rowState?.reditor}</div>
                  </div>
                </div>
              )}
            </div>
          </SubRoot>
          <ButtonsWrapper>
            {auth.deleteAuth && !isNewAdd && (userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer) && (
              <BtnRed onClick={() => onClickDelete(activeTab)}>{t('삭제')}</BtnRed>
            )}
            {auth.createAuth && (
              <>
                <div className='description'>{t('개별 이미지 당 5MB 까지 첨부 가능')}</div>
                <div className='addImgBtn'>
                  <input
                    className='hiddenFileBox'
                    style={{ width: '50%', lineHeight: '2' }}
                    type='file'
                    multiple
                    accept='image/jpg, image/png, image/jpeg'
                    id='filebox'
                    name='dIfilename'
                    ref={inputFileRef}
                    onChange={(e) => handleFileInputChange(e, activeTab)}
                    disabled={!(isNewAdd || userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer)}
                  />

                  <label htmlFor='filebox'>
                    <div className={`fileButton ${!(isNewAdd || userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer) ? 'disabled' : ''}`} id='filebox'>
                      <span className='material-symbols-rounded'>image </span>
                      <span role='button' tabIndex={0} onClick={() => handleFlutterFilePicker(undefined, 'image', false)}>
                        {t('이미지 추가')}
                      </span>
                    </div>
                  </label>
                </div>
              </>
            )}
            {activeTab === CORRECT_TAB && boardDtableState?.length > 0 && <BtnGreen onClick={() => onClickPreview(boardDtableState)}>{t('미리보기')}</BtnGreen>}
            {activeTab === ACTION_TAB && boardRDtableState?.length > 0 && <BtnGreen onClick={() => onClickPreview(boardRDtableState)}>{t('미리보기')}</BtnGreen>}
            {(auth.createAuth || auth.updateAuth) && (isNewAdd || userInfo.gCd === 'MM' || userInfo.gCd === 'CM' || userInfo.userName === rowState.writer) && (
              <BtnBlue onClick={() => onClickSave(activeTab)}>{t('저장')}</BtnBlue>
            )}
          </ButtonsWrapper>
        </Root>
      )}

      <Portal openModal={openModal?.status}>
        {openModal && openModal.title === 'delete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}
        {openModal && openModal.title === 'imgDelete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}
        {openModal && openModal.type === 'dashboardView' && <DashboardViewModalSlider openModal={openModal} setOpenModal={setOpenModal} />}
      </Portal>

      {size.innerSize.W <= 1024 && (
        <Portal openModal>
          <SearchFilterModal openModal={openModal} setOpenModal={setOpenModal} onClickSearch={onClickSearch} onClickReset={onClickInitiateSearchOption}>
            <div className='filter-option-wrapper'>
              <div className='filter-option-col filter-underline filter-option-date'>
                <span className='calendarLabel'>{t('적용일자')}</span>
                <div className='inputForm-col'>
                  <div className='flex-basic' role='presentation' onClick={onClickRangeInput}>
                    <input id='startInput' type='text' readOnly value={searchOption.start} onChange={(e) => onChangeRangeInput(e, 'start', setRangeState, setSearchOption)} />
                    <span className='inputDash'> ~ </span>
                    <input id='endInput' type='text' readOnly value={searchOption.end} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setSearchOption)} />
                  </div>
                  {visibleRangePicker && (
                    <div className='rangePickerWrapper'>
                      <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} style={{ left: '70%' }} />
                    </div>
                  )}
                </div>
              </div>
              <div className='filter-option-cont'>
                <div className='filter-option-row'>
                  <label htmlFor='useYn'>{t('보기 설정')}</label>
                  <SelectBox
                    options={listCountComCdList}
                    defaultOption={listCount.cdName}
                    state={listCount}
                    setState={setListCount}
                    stateKey={LIST_COUNT}
                    initiateKey={listCount[LIST_COUNT]}
                    setTableLinesAPI={patchUserMenuAPI}
                    optionHeight='height-sm'
                    rsearch
                  />
                </div>
                <div className='filter-option-row'>
                  <label htmlFor='cbtYn'>{t('상황판 적용유무')}</label>
                  <div className='inputForm-col'>
                    <SelectBox
                      options={CBT_DEFAULTS}
                      defaultOption={t('전체')}
                      state={cbtYn}
                      setState={setCbtYn}
                      stateKey='cbtYn'
                      initiateKey={cbtYn.cbtYn}
                      filterbar='filter-1-left'
                      optionHeight='height-md'
                    />
                  </div>
                </div>
              </div>
            </div>
          </SearchFilterModal>
        </Portal>
      )}
    </div>
  );
};

export default Correct;
